import React, { useState } from "react"
import { MenuLink } from "@reach/menu-button"
import Card from "@kit/design/card"
import Button from "@kit/design/button"
import { calloutMap } from "app/navigation/utils/callout-map"
import analytics from "utils/analytics"
import PlanComparison from "../../shared/components/plan-comparison"

const trackClick = () => {
  analytics.track(
    "Element",
    "Clicked",
    {
      name: "profile_dropdown_upgrade_now",
      text: "Upgrade now"
    },
    { transport: "beacon" }
  )
}

export function UpgradeCallout({ userInfo }) {
  const [
    showCallout,
    calloutLink,
    calloutContent,
    openPlanComparison,
    planComparisonModalContent
  ] = calloutMap(userInfo)
  const [showPlanComparison, setShowPlanComparison] = useState(false)

  const handleClick = e => {
    if (openPlanComparison) {
      e.preventDefault()
      setShowPlanComparison(true)
    }

    trackClick()
  }

  const handleCelebration = () => {
    analytics.track(
      "Element",
      "Clicked",
      {
        element_type: "button",
        name: "learn_more_upgrade_callout",
        text: "Learn more"
      },
      { transport: "beacon" }
    )

    window.location.reload()
  }

  return (
    <React.Fragment>
      {showCallout && (
        <MenuLink
          className="rounded-lg settings-note mb-2 p-0 group"
          style={{ padding: 0 }}
          href={calloutLink}
          onClick={handleClick}
        >
          <Card className="bg-blue-50">
            <h2 className="pb-2 text-sm font-semibold group-hover:text-gray-800">
              {calloutContent["header"]}
            </h2>

            <div className="mb-5 text-gray-800 group-hover:text-gray-800 text-sm whitespace-pre-wrap">
              {calloutContent["text"]}
            </div>

            <Button is="primary">{calloutContent["buttonText"]}</Button>
          </Card>
        </MenuLink>
      )}
      {showPlanComparison && (
        <PlanComparison
          title={planComparisonModalContent["title"]}
          description={planComparisonModalContent["description"]}
          serviceLevels={planComparisonModalContent["plans"]}
          onClose={() => setShowPlanComparison(false)}
          afterCelebration={handleCelebration}
          prioritizedServiceLevel={
            planComparisonModalContent["prioritizedPlan"]
          }
        />
      )}
    </React.Fragment>
  )
}
